/**
 * Permission keys that gate each Settings page, kept in one place so the
 * sidebar and the header user-menu "Settings" link always agree on whether
 * Settings is reachable at all. All of these default to
 * super_admin + administrator only; every other role starts with none of
 * them until a super_admin explicitly grants access via the role editor.
 */
export const SETTINGS_PAGE_PERMISSIONS = [
  'manage_agents',
  'manage_groups',
  'manage_roles',
  'manage_tags',
  'field_admin',
  'form_admin',
  'sla_admin',
  'manage_automations',
  'manage_email_config',
  'manage_notification_templates',
  'manage_api_keys',
  'manage_canned_responses',
  'manage_kb',
  'manage_jira',
] as const;

/**
 * Whether the Settings section should be visible/navigable at all — true if
 * the role has the umbrella `settings_admin` grant, or has been granted
 * access to at least one individual Settings page.
 */
export function canSeeSettings(can: (permission: string) => boolean): boolean {
  return can('settings_admin') || SETTINGS_PAGE_PERMISSIONS.some((permission) => can(permission));
}
